export default {
  setSubscription({ commit }, payload) {
    commit('subscription', payload)
  },
  hasActiveSubscription({ state }) {
    return state.subscription && (state.subscription?.status === 'active' 
      || state.subscription?.status === 'trialing')
  }
}